export default __webpack_public_path__ + "static/media/REFERRALPATIENT.fb20a1de.png";